import React from 'react'
import i18n from 'i18next'
import { storeMobx, decorationMobx } from '@mobxStore'

interface IProps {
  data: any;
}

const Demo: React.FC<IProps> = (props) => {
  const cpMap = {
    cash: {
      bg: '135deg, #f1a59f 0%, #dd7065 100%',
      label: i18n.t('mkt.coupon.cashCoupons')
    },
    order: {
      bg: '137deg, #e6c8a1 0%, #d5a973 100%',
      label: i18n.t('mkt.coupon.orderCoupons')
    },
    designate: {
      bg: '137deg, #e6c8a1 0%, #d5a973 100%',
      label: i18n.t('mkt.coupon.fullDiscountCoupons')
    },
    item: {
      bg: '135deg, #85b9da 0%, #6b9ad9 100%',
      label: i18n.t('mkt.coupon.itemCoupons')
    },
    ladder: {
      bg: '135deg, #85b9da 0%, #6b9ad9 100%',
      label: i18n.t('mkt.coupon.fullDiscountCoupons')
    },
    express: {
      bg: '135deg, #85dad2 0%, #45b5b2 100%',
      label: i18n.t('mkt.coupon.expressCoupons')
    }
  }
  const { data } = props
  const { brand } = storeMobx
  const { globalDecorates } = decorationMobx
  return (
    <div style={{ width: '375px', height: '667px', backgroundImage: 'url(https://eshine-image-test.oss-cn-hangzhou.aliyuncs.com/20220713/09415535dede0d28.jpg)', backgroundSize: 'cover', backgroundPosition: 'center center', position: 'relative' }}>
      <div style={{ background: '#fff', position: 'absolute', left: '32px', right: '32px', top: '110px', textAlign: 'center', padding: '32px 28px 24px', boxShadow: '0 3px 10px 0 rgba(0,0,0,0.14)' }}>
        <div style={{ fontSize: '12px', color: '#b3b3b3', paddingBottom: '7px' }}>{i18n.t('mkt.coupon.sendCouponNum', { name: data.giverName, num: data.cnt })}</div>
        <div>
          <div style={{ display: 'inline-block', width: '80px', borderTop: '1px dashed #e8e8e8' }}></div>
          <img style={{ display: 'inline-block', width: '54px', height: '54px', borderRadius: '50%', margin: '0 13px' }} src={brand.logo} />
          <div style={{ display: 'inline-block', width: '80px', borderTop: '1px dashed #e8e8e8' }}></div>
        </div>
        <div style={{ fontSize: '14px', color: '#b3b3b3', paddingTop: '44px' }}>{data.receiverName}:</div>
        <div style={{ fontSize: '32px', paddingTop: '12px' }}>“ {data.message} ”</div>
        <div style={{ maxHeight: '150px', overflow: 'hidden', paddingTop: '38px', borderBottom: '1px dashed #e8e8e8' }}>
          {
            data.coupons.map((item: any) => (
              <div key={item.couponId} style={{ height: '90px', marginBottom: '8px', position: 'relative', borderRadius: '6px', background: '#f5f5f5' }}>
                {
                  item.picture
                    ? <div style={{ position: 'absolute', left: '0', top: '0', width: '90px', height: '90px', borderRadius: '6px 0 0 6px', backgroundImage: `url(${item.picture})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}></div>
                    : <div style={{ position: 'absolute', left: '0', top: '0', width: '90px', height: '90px', borderRadius: '6px 0 0 6px', background: `linear-gradient(${cpMap[item.type].bg})`, fontSize: '16px', lineHeight: '90px', color: '#fff', fontWeight: '600', textAlign: 'center' }}>{window.bo === 'cn' ? cpMap[item.type].label : 'coupon'}</div>
                }
                <div style={{ position: 'absolute', left: '90px', top: '0', width: '130px', height: '90px', textAlign: 'left', paddingLeft: '8px' }}>
                  <div style={{ fontSize: '14px', paddingTop: '24px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.couponName}</div>
                  <div style={{ fontSize: '12px', color: '#7a7a7a', paddingTop: '4px' }}>{item.discountTitle}</div>
                </div>
                {item.count > 1 && <div style={{ position: 'absolute', right: '12px', top: '32px', color: '#7a7a7a', fontSize: '16px' }}>x{item.count}</div>}
              </div>
            ))
          }
        </div>
        <a href={data.url} style={{ display: 'block', width: '140px', height: '40px', lineHeight: '40px', textAlign: 'center', fontSize: '14px', margin: '14px auto 0', background: globalDecorates.themeColor, borderRadius: '24px', color: '#ffffff', textDecoration: 'none' }}>{i18n.t('mkt.common.seeDetails')}</a>
      </div>
    </div>
  )
}

export default Demo
